/* ログイン(申込人) */
import React from 'react';
import ReactDOM from 'react-dom';
import Block from '../../molecules/Block';
import Text from '../../molecules/Text';
import Annotation from '../../atoms/Annotation';
import CenterButton from '../../atoms/CenterButton';

const Login: React.FC = () => {
  return (
    <>
      <div className="mt-5"></div>
      <Block
        label="ログイン"
        content={
          <>
            <Annotation text="ご登録のログインID(メールアドレス)とパスワードを入力して下さい。" />
            <div className="mt-3"></div>
            <div>
              <Text
                id="email"
                label="ログインID"
                value=""
                placeholder=""
                disabled={false}
                handleChange={() => {}}
                maxlength={200}
              />
              <Text
                id="password"
                label="パスワード"
                value=""
                placeholder=""
                disabled={false}
                handleChange={() => {}}
                maxlength={200}
              />
            </div>
          </>
        }
      />
      <div className="mt-5" />
      <CenterButton label="ログイン" />
      <div className="mt-3" />
    </>
  );
};

if (document.getElementById('application-person-login')) {
  ReactDOM.render(<Login />, document.getElementById('application-person-login'));
}
